const MISSING_REFRESH_TOKEN = '__missing_refresh_token__'

export function isRefreshRequest(config) {
  if (config?.skipAuthRefresh) return true

  const url = String(config?.url || '').split('?')[0].replace(/\/+$/, '')
  return url.endsWith('/api/auth/refresh')
}

export function createRefreshCoordinator({
  getRefreshToken,
  refresh,
  updateToken,
  logout,
  redirect
}) {
  let activeRefresh = null
  let activeRefreshToken = null
  let expiredSessionToken = null

  const expireSession = (refreshToken) => {
    const sessionToken = refreshToken || expiredSessionToken || MISSING_REFRESH_TOKEN
    if (expiredSessionToken === sessionToken) return

    expiredSessionToken = sessionToken
    logout()
    redirect()
  }

  const refreshAccessToken = () => {
    const refreshToken = getRefreshToken()

    if (!refreshToken) {
      expireSession(refreshToken)
      return Promise.reject(new Error('Refresh token indisponível'))
    }

    if (activeRefresh && activeRefreshToken === refreshToken) {
      return activeRefresh
    }

    const refreshPromise = Promise.resolve()
      .then(() => refresh(refreshToken))
      .then((accessToken) => {
        if (!accessToken) {
          throw new Error('Resposta de refresh sem access token')
        }

        if (getRefreshToken() !== refreshToken) {
          const error = new Error('Sessão alterada durante a renovação')
          error.code = 'AUTH_SESSION_CHANGED'
          throw error
        }

        expiredSessionToken = null
        updateToken(accessToken)
        return accessToken
      })
      .catch((error) => {
        if (getRefreshToken() === refreshToken) {
          expireSession(refreshToken)
        }
        throw error
      })
      .finally(() => {
        if (activeRefresh === refreshPromise) {
          activeRefresh = null
          activeRefreshToken = null
        }
      })

    activeRefresh = refreshPromise
    activeRefreshToken = refreshToken
    return refreshPromise
  }

  return { refreshAccessToken }
}
